"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
define('rs/form/formobjects/comments.view',['vertebrae', 'rs/helper', 'rs/models/docstore', 'rs/form/editelement', 'evisions/redactor.plugins/docstore.redactor.plugin', 'select2'], function (Vertebrae, helper, DocstoreModel, EditElement) {
  var CommentsView = Vertebrae.View.extend({
    templates: {
      'comments.init': 'renderInitFragment',
      'comments.item': 'renderCommentItemFragment',
      'comments.reply': 'renderReplyFragment'
    },
    events: {
      'change [data-action="hide"]': 'onCommentHideChange',
      'change [data-action="resolve"]': 'onCommentResolveChange',
      'change [data-action="address"]': 'onCommentAddressChange',
      'click .toolbar-actions .btn': 'handleCommentToolbarEvnt',
      'click .close-comments': 'handleCloseCommentClick',
      'click .comment-add-btn': 'handleCommentAddBtn',
      'click .comment-cancel-reply-btn': 'handleCommentCancelReplyBtn',
      'click .comment-reply-btn': 'handleCommentReplyBtn',
      'click .toggle-comment-add': 'handleShowCommentAddBtn',
      'click .filter-comments-btn': 'handleFilterCommentsBtn',
      'click .comment-add-link': 'toggleAddComment',
      'click .command-add-action-container': 'handleAddCommentContainerClick',
      'mouseover .redactor-inline-attachment': 'handleAttachedDocumentFocus',
      'keydown .toolbar-actions .btn': 'handleCommentToolbarEvnt',
      'keydown .close-comments': 'handleCloseCommentClick',
      'keydown .comment-add-btn': 'handleCommentAddBtn',
      'keydown .comment-cancel-reply-btn': 'handleCommentCancelReplyBtn',
      'keydown .comment-reply-btn': 'handleCommentReplyBtn',
      'keydown .toggle-comment-add': 'handleShowCommentAddBtn',
      'keydown .filter-comments-btn': 'handleFilterCommentsBtn',
      'keydown .comment-add-link': 'toggleAddComment',
      'keydown .command-add-action-container': 'handleAddCommentContainerClick',
      'keydown .redactor-inline-attachment': 'handleAttachedDocumentFocus',
      'keyup .redactor-inline-attachment': 'handleAttachedDocumentFocus'
    },
    redactorSettings: {
      fileUpload: true,
      multipleUpload: true,
      plugins: ['docstore', 'imageEmbed'],
      buttons: ['bold', 'italic', 'underline', 'deleted', '|', 'unorderedlist', 'orderedlist']
    },
    getRedactorSettings: function getRedactorSettings() {
      var doc = this.getDelegate().getFormController().getDocumentModel();
      var redactorSettings = _.extend({}, this.redactorSettings, {
        uploadImageUrl: DocstoreModel.getRelativeImageURL(doc.getId()),
        tabFocus: false,
        documentId: doc.getId()
      });
      return redactorSettings;
    },
    render: function render() {
      var delegate = this.getDelegate(),
        doc = delegate.getFormController().getDocumentModel(),
        redactorSettings = this.getRedactorSettings(),
        redactor = null,
        properties = delegate.getViewProperties();
      this.$el.html(this.renderInitFragment(properties));
      this.refreshCommentList();
      if (properties.canAdd) {
        this.addRedactor = redactor = this.$el.children('.comment-add').find('textarea').redactor(redactorSettings).data().redactor;
      }
      if (properties.canAdd && properties.comments.length < 1) {
        this.showCommentAdd();
        redactor.focus();
      }
    },
    refreshCommentList: function refreshCommentList() {
      var container = this.$('.comment-list'),
        comments = this.getDelegate().getComments();
      container.empty();
      _.each(comments, _.bind(this.renderComment, this, container));
    },
    renderComment: function renderComment(container, comment, index, list, template, parent) {
      var _tempDiv$querySelecto;
      var context = {
        index: index,
        first: index === 0,
        last: index == list.length - 1,
        even: index % 2 === 0,
        odd: false
      };
      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = comment === null || comment === void 0 ? void 0 : comment.text;
      var linkText = tempDiv === null || tempDiv === void 0 || (_tempDiv$querySelecto = tempDiv.querySelector('a')) === null || _tempDiv$querySelecto === void 0 ? void 0 : _tempDiv$querySelecto.textContent;
      function createModel(item) {
        return {
          commendId: comment.id,
          detail: item.detail,
          text: item.text,
          state: item.state,
          id: item.state,
          selected: item.preselected
        };
      }
      function initSelection(data) {
        return function (el, callback) {
          callback(_.findWhere(data, {
            state: el.val()
          }));
        };
      }
      function formatSelection(item) {
        return item.state;
      }
      function formatResult(item) {
        return item.text;
      }
      context.odd = !context.even;
      var div = $(document.createElement('div'));
      var restrictedDetail = 'Researchers can not see comment';
      var unrestrictedDetail = 'Anyone with access to study can see';
      var hideData = _.map([{
        state: 'Unrestricted',
        text: 'Unrestricted',
        detail: unrestrictedDetail,
        preselected: !comment.hidden
      }, {
        state: 'Restricted',
        text: 'Restricted',
        detail: restrictedDetail,
        preselected: comment.hidden
      }], createModel);
      var resolveData = _.map([{
        state: 'Resolved',
        text: 'Resolve',
        preselected: !!comment.resolvedDate
      }, {
        state: 'Not Resolved',
        text: 'Unresolve',
        preselected: !comment.resolvedDate
      }], createModel);
      var addressData = _.map([{
        state: 'Addressed',
        text: 'Address',
        preselected: !!comment.addressedDate
      }, {
        state: 'Not Addressed',
        text: 'Unaddress',
        preselected: !comment.addressedDate
      }], createModel);
      div.html(Vertebrae.View.template(template || 'comments.item', _objectSpread(_objectSpread({}, comment), {}, {
        title: linkText
      }), {
        data: context
      }));
      if (!parent || !parent.hidden) {
        div.find('[data-action="hide"]').select2({
          data: hideData,
          minimumResultsForSearch: Infinity,
          width: '50%',
          placeholder: 'Hidden',
          templateSelection: function templateSelection() {
            return 'Visibility: ' + formatSelection.apply(this, arguments);
          },
          templateResult: function templateResult(item) {
            if (!item.id) {
              return item.text;
            }
            return $result = $('<span>' + formatResult(item) + '<div style="font-size: 10px;">' + item.detail + '</div>' + '</span>');
          }
        }).val(comment.hidden ? hideData[1].state : hideData[0].state).trigger('change');
      }
      if (comment.canResolve) {
        if (comment.needsResolve || comment.resolved) {
          div.find('[data-action="resolve"]').select2({
            data: resolveData,
            minimumResultsForSearch: Infinity,
            width: '50%',
            placeholder: 'resolve',
            templateSelection: formatSelection,
            templateResult: formatResult
          }).val(comment.resolvedDate ? resolveData[0].state : resolveData[1].state).trigger('change');
        }
      } else {
        if (comment.needsAddress || comment.addressed) {
          div.find('[data-action="address"]').select2({
            data: addressData,
            minimumResultsForSearch: Infinity,
            width: '50%',
            placeholder: 'address',
            templateSelection: formatSelection,
            templateResult: formatResult
          }).val(comment.addressedDate ? addressData[0].state : addressData[1].state).trigger('change');
        }
      }
      var $replyList = div.find('.comment-reply-list');
      _.each(comment.replies, function (reply, index, list) {
        this.renderComment($replyList, reply, index, list, 'comment.replyitem', comment);
      }, this);
      container.append(div.children());
      return this;
    },
    showCommentAdd: function showCommentAdd() {
      this.$('.comment-add').show();
      this.$('.comment-add-link').hide();
    },
    setFilterText: function setFilterText(text) {
      return this.$('.filter-comments-btn').text(text).show();
    },
    showAllComments: function showAllComments() {
      this.$('.comment-list').find('.comment-item.is-filtered').slideDown().removeClass('is-filtered');
    },
    showEmptyMessage: function showEmptyMessage() {
      this.$('.comment-list .empty-item').slideDown();
    },
    hideEmptyMessage: function hideEmptyMessage() {
      this.$('.comment-list .empty-item').slideUp();
    },
    hideCommentById: function hideCommentById(id) {
      this.$('.comment-list').find('[data-id="' + id + '"]').slideUp().addClass('is-filtered');
    },
    refreshCommentListOrder: function refreshCommentListOrder() {
      var items = this.$('.comment-list').find('.comment-item').not('.is-filtered');
      for (var i = 0, len = items.length; i < len; ++i) {
        items.eq(i).attr('data-index', i);
        if (i % 2 === 0) {
          items.eq(i).removeClass('odd');
        } else {
          items.eq(i).addClass('odd');
        }
      }
    },
    toggleAddComment: function toggleAddComment(ev) {
      if (ev.type === 'keydown' && 13 !== ev.keyCode) {
        return;
      }
      var d = Promise.defer(),
        that = this;
      var addComment = this.$('.comment-add').slideToggle(function () {
        if (addComment.is(":visible")) {
          that.addRedactor.focus();
        }
        d.resolve();
      });
      this.$('.comment-add-link').slideToggle();
      return d.promise;
    },
    clearCommentText: function clearCommentText() {
      this.addRedactor.set('');
    },
    getCommentText: function getCommentText() {
      return this.addRedactor.get();
    },
    toggle: function toggle() {
      var d = Promise.defer();
      this.getDelegate().getFormObject().getView().getCommentIconContainer().toggleClass('open');
      this.$el.slideToggle(function () {
        d.resolve();
      });
      return d.promise;
    },
    closePreviousComment: function closePreviousComment() {
      if (this.previousSelectedComment) {
        this.previousSelectedComment.removeClass('open').find('.comment-item-contents').slideUp().end().find('.comment-reply-container').slideUp().end().find('.comment-reply-list').slideUp();
      }
    },
    handleCommentClick: function handleCommentClick(ev) {
      ev.stopPropagation();
      var el = $(ev.currentTarget).closest('.comment-item');
      this.closePreviousComment();
      if (this.previousSelectedComment == null || el.get(0) !== this.previousSelectedComment.get(0)) {
        this.previousSelectedComment = el;
        var commentReplyContainer = this.previousSelectedComment.addClass('open').find('.comment-item-contents').slideDown().end().find('.comment-reply-container');
        if (commentReplyContainer.hasClass('open')) {
          commentReplyContainer.slideDown();
        }
      } else {
        this.previousSelectedComment = null;
      }
    },
    handleCommentToolbarEvnt: function handleCommentToolbarEvnt(ev) {
      if (ev.type === 'keydown' && 13 !== ev.keyCode) {
        return;
      }
      ev.stopPropagation();
      var el = $(ev.currentTarget),
        action = el.data('action'),
        fn = 'handleComment' + helper.camelCase(action + '') + 'Action';
      if (this[fn]) {
        this[fn](el.closest('.comment-item,.comment-reply-item'), ev);
      }
    },
    handleCommentCloseAction: function handleCommentCloseAction(ev) {
      this.closePreviousComment();
      this.previousSelectedComment = null;
    },
    handleCommentDeleteReplyAction: function handleCommentDeleteReplyAction(el, ev) {
      var commentIndex = el.closest('.comment-item').data('index'),
        replyIndex = el.data('index');
      this.getDelegate().requestDeleteReplyCommentAtIndex(commentIndex, replyIndex).bind(this).tap(this.refreshCommentList);
    },
    handleCommentDeleteAction: function handleCommentDeleteAction(el, ev) {
      var commentIndex = el.data('index');
      this.getDelegate().requestDeleteCommentAtIndex(commentIndex).bind(this).tap(this.refreshCommentList);
    },
    handleCommentEditAction: function handleCommentEditAction(el, ev) {
      var id = el.data('id'),
        message = el.find('.comment-body-title').eq(0),
        original = message.html(),
        edit = null,
        that = this,
        delegate = this.getDelegate(),
        container = this.getDelegate().getFormObject().getSectionController().getView().$el;
      edit = EditElement.delegate(message).rich(function () {
        return true;
      }).container(function () {
        return container;
      }).redactorOptions(function () {
        return that.getRedactorSettings();
      }).edit(function (el, property, text, cancel) {
        edit.destroy();
        if (cancel) {
          return;
        }
        delegate.requestCommentEditAtId(id, text).fail(function () {
          message.html(original);
        });
      }).enterEdit(message);
    },
    handleCommentResolveAction: function handleCommentResolveAction(el, ev) {
      var index = el.data('index');
      this.getDelegate().requestResolveCommentToggleAtIndex(index).bind(this).tap(this.refreshCommentList);
    },
    handleCommentAddressAction: function handleCommentAddressAction(el, ev) {
      var index = el.data('index');
      this.getDelegate().requestAddressCommentToggleAtIndex(index).bind(this).tap(this.refreshCommentList);
    },
    handleCommentHideAction: function handleCommentHideAction(el, ev) {
      var id = el.data('id');
      if (id != null) {
        this.getDelegate().requestToggleHideCommentAtId(id).bind(this).tap(function () {
          this.refreshCommentList();
        });
      }
    },
    onCommentHideChange: function onCommentHideChange(ev) {
      var el = $(ev.currentTarget).closest('.comment-item,.comment-reply-item');
      if (el.length) {
        this.handleCommentHideAction(el, ev);
      }
    },
    onCommentResolveChange: function onCommentResolveChange(ev) {
      var el = $(ev.currentTarget).closest('.comment-item,.comment-reply-item');
      if (el.length) {
        this.handleCommentResolveAction(el, ev);
      }
    },
    onCommentAddressChange: function onCommentAddressChange(ev) {
      var el = $(ev.currentTarget).closest('.comment-item,.comment-reply-item');
      if (el.length) {
        this.handleCommentAddressAction(el, ev);
      }
    },
    handleCommentReplyAction: function handleCommentReplyAction(el, ev) {
      el = el.closest('.comment-item');
      if (el.hasClass('open-reply')) {
        return this.hideReplyContainer(el);
      } else {
        return this.showReplyContainer(el);
      }
    },
    showReplyContainer: function showReplyContainer(el) {
      var d = Promise.defer(),
        container = null,
        redactor = null,
        textarea = null;
      container = el.find('.comment-reply-container');
      el.addClass('open-reply');
      container.addClass('open').html(this.renderReplyFragment());
      textarea = container.find('textarea');
      this.replyRedactor = redactor = textarea.redactor(this.getRedactorSettings()).data().redactor;
      container.slideDown(function () {
        d.resolve();
      });
      d.then(function () {
        redactor.focus();
      });
      return d.promise;
    },
    hideReplyContainer: function hideReplyContainer(el) {
      var d = Promise.defer(),
        container = null;
      el.removeClass('open-reply');
      container = el.find('.comment-reply-container').removeClass('open').slideUp(function () {
        d.resolve();
      });
      d.then(function () {
        container.html('');
      });
      return d.promise;
    },
    addReplyToComment: function addReplyToComment(el, reply, last) {
      var html = Vertebrae.View.template('comment.replyitem', reply, {
        data: {
          last: last
        }
      });
      el.find('.comment-reply-list').append(html);
    },
    handleCommentCancelReplyBtn: function handleCommentCancelReplyBtn(ev) {
      if (ev.type === 'keydown' && 13 !== ev.keyCode) {
        return;
      }
      ev.stopPropagation();
      var el = $(ev.currentTarget).closest('.comment-item');
      this.hideReplyContainer(el);
    },
    handleCommentReplyBtn: function handleCommentReplyBtn(ev) {
      if (ev.type === 'keydown' && 13 !== ev.keyCode) {
        return;
      }
      ev.stopPropagation();
      if (!this.replyRedactor) {
        return;
      }
      var el = $(ev.currentTarget).closest('.comment-item'),
        text = this.replyRedactor.get(),
        delegate = this.getDelegate(),
        index = el.data('index'),
        that = this;
      delegate.requestCommentReply(index, text).then(function (reply) {
        that.hideReplyContainer(el);
        that.refreshCommentList();
      });
    },
    handleCloseCommentClick: function handleCloseCommentClick(ev) {
      if (ev.type === 'keydown' && 13 !== ev.keyCode) {
        return;
      }
      ev.stopPropagation();
      this.getDelegate().toggle();
    },
    handleShowCommentAddBtn: function handleShowCommentAddBtn(ev) {
      if (ev.type === 'keydown' && 13 !== ev.keyCode) {
        return;
      }
      ev.stopPropagation();
      this.toggleAddComment();
      this.addRedactor.focus();
    },
    handleFilterCommentsBtn: function handleFilterCommentsBtn(ev) {
      if (ev.type === 'keydown' && 13 !== ev.keyCode) {
        return;
      }
      ev.stopPropagation();
      this.getDelegate().switchFilter();
    },
    handleCommentAddBtn: function handleCommentAddBtn(ev) {
      if (ev.type === 'keydown' && 13 !== ev.keyCode) {
        return;
      }
      ev.stopPropagation();
      var that = this,
        text = this.getCommentText();
      if (text) {
        this.getDelegate().addComment(text).then(function () {
          that.clearCommentText();
        });
      }
    },
    handleAddCommentContainerClick: function handleAddCommentContainerClick() {
      if (this.addRedactor) {
        this.addRedactor.focus();
      }
    },
    setTitleforAttached: function setTitleforAttached(className, title) {
      if (className === 'redactor-inline-attachment') {
        this.getDelegate().view.$el.find('.redactor-inline-attachment').attr('title', title);
      }
    },
    handleAttachedDocumentFocus: function handleAttachedDocumentFocus(e) {
      if ((e === null || e === void 0 ? void 0 : e.keyCode) === 9) {
        var _e$target;
        this.setTitleforAttached(e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.className, null);
      } else {
        var _e$target2, _e$target3;
        this.setTitleforAttached(e === null || e === void 0 || (_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : _e$target2.className, e === null || e === void 0 || (_e$target3 = e.target) === null || _e$target3 === void 0 ? void 0 : _e$target3.innerText);
      }
    }
  });
  return CommentsView;
});

